/* @flow weak */
import enumerate from 'lib/enumerate';

export const ActionTypes = enumerate([
  'LOAD_SETTINGS',
]);



// WEBPACK FOOTER //
// ./src/constants/SettingConstants.js